export let static_question = [
    {
        question: "Which HTML tag is used to define a hyperlink?",
        option: ["<a>", "<link>", "<href>", "<hyperlink>"],
        answer: "<a>"
    },
    {
        question: "What does HTML stand for?",
        option: ["Hyperlinks and Text Markup Language", "Home Tool Markup Language", "Hyper Text Markup Language", "Hyper Tool Mark Language"],
        answer: "Hyper Text Markup Language"
    },
    {
        question: "Which tag is used to insert an image in HTML?",
        option: ["<image>", "<img>", "<src>", "<pic>"],
        answer: "<img>"
    },
    {
        question: "How can you make a numbered list in HTML?",
        option: ["<ul>", "<ol>", "<list>", "<dl>"],
        answer: "<ol>"
    },
    {
        question: "Which tag is used for the largest heading in HTML?",
        option: ["<heading>", "<h6>", "<h1>", "<head>"],
        answer: "<h1>"
    },
    {
        question: "What is the correct HTML element for inserting a line break?",
        option: ["<break>", "<br>", "<lb>", "<line>"],
        answer: "<br>"
    },
    {
        question: "Which tag is used to define a table row?",
        option: ["<th>", "<td>", "<tr>", "<table>"],
        answer: "<tr>"
    },
    {
        question: "Which HTML tag is used to define an internal style sheet?",
        option: ["<script>", "<style>", "<css>", "<link>"],
        answer: "<style>"
    },
    {
        question: "Which attribute specifies an alternate text for an image?",
        option: ["title", "src", "alt", "href"],
        answer: "alt"
    },
    {
        question: "Which input type defines a checkbox?",
        option: ["text", "button", "checkbox", "radio"],
        answer: "checkbox"
    },
    {
        question: "What is the correct HTML for creating a drop-down list?",
        option: ["<dropdown>", "<select>", "<input type='dropdown'>", "<list>"],
        answer: "<select>"
    },
    {
        question: "How do you create a comment in HTML?",
        option: ["// comment", "# comment", "<!-- comment -->", "** comment **"],
        answer: "<!-- comment -->"
    },
    {
        question: "Which tag is used to create an unordered list?",
        option: ["<ol>", "<ul>", "<li>", "<dl>"],
        answer: "<ul>"
    },
    {
        question: "Which tag is used to define a cell in a table?",
        option: ["<td>", "<tr>", "<th>", "<table>"],
        answer: "<td>"
    },
    {
        question: "Which HTML element defines the title of a document?",
        option: ["<meta>", "<head>", "<title>", "<h1>"],
        answer: "<title>"
    },
    {
        question: "Which tag is used to group together form elements?",
        option: ["<group>", "<fieldset>", "<div>", "<section>"],
        answer: "<fieldset>"
    },
    {
        question: "Which tag is used to embed a webpage within a webpage?",
        option: ["<frame>", "<iframe>", "<embed>", "<object>"],
        answer: "<iframe>"
    },
    {
        question: "Which tag is used to define emphasized text?",
        option: ["<strong>", "<bold>", "<em>", "<i>"],
        answer: "<em>"
    },
    {
        question: "What is the correct HTML element to define important text?",
        option: ["<em>", "<strong>", "<important>", "<b>"],
        answer: "<strong>"
    },
    {
        question: "Which HTML attribute is used to define inline styles?",
        option: ["class", "style", "font", "styles"],
        answer: "style"
    }
];


// export let static_question = [
//     {
//         question: "Choose the correct combination of prepositions to complete the sentence: The cat jumped _______ the table ______ the chair.",
//         option: ["on, from", "off, in", "into, beside", "onto, towards"],
//         answer: "onto, towards"
//     },
// ]